import React, { useContext, useEffect, useState } from 'react';
import { Button, IconButton, TextField, Modal, Card, CardContent, Typography, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { format } from 'date-fns';
import axios from 'axios';
import Swal from 'sweetalert2';
import UserContext from '../../Context/User/userContext';

const ActivityPageForUser = ({ setShowSpinner, data }) => {
  const { user, setUser } = useContext(UserContext);
  // Bearer Token
  const token = localStorage.getItem('token');
  const tokenValue = token ? token.slice(1, token.length - 1) : "";
  const userObj = user && (typeof user === 'string' ? JSON.parse(user) : user);
  const _id = userObj && userObj._id;

  const [open, setOpen] = useState(false);
  const [activityData, setActivityData] = useState({ date: format(new Date(), 'yyyy-MM-dd'), text: '' });
  const [activities, setActivities] = useState(data[0].activity || []);
  const [isAdmin, setIsAdmin] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    const currentTime = format(new Date(), 'hh:mm:ss a'); // Updated time format with AM/PM
    const newActivity = { ...activityData, time: currentTime };

    setShowSpinner(true);
    // URL for saving study information
    let saveUrl;
    if (isAdmin) {
      saveUrl = `https://research-mate-b35a10757d5a.herokuapp.com/api/adminStudy/activity/${data[0]._id}`;
    } else {
      saveUrl = `https://research-mate-b35a10757d5a.herokuapp.com/api/myStudy/activity/${data[0]._id}`;
    }

    // Make the API request to save study information
    axios.post(saveUrl, newActivity, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${tokenValue}`
      }
    })
      .then(res => {
        setActivities(res.data.study.activity);
        Swal.fire({
          title: "Added!",
          text: "Your Activity has been added",
          icon: "success",
          customClass: {
            container: 'swal2-container-custom'
          }
        });
      })
      .catch(error => {
        console.log("Error:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response?.data?.message || error.message,
          customClass: {
            container: 'swal2-container-custom'
          }
        });
      })
      .finally(() => {
        setActivityData({ date: format(new Date(), 'yyyy-MM-dd'), text: '' });
        setShowSpinner(false);
        //Close Modal
        setOpen(false);
      })
  };

  const checkForAdmin = async () => {
    try {
      const response = await axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/auth/validateAdmin/${_id}`, {
        headers: {
          'Authorization': `Bearer ${tokenValue}`
          // You can add other headers if needed like authorization token, etc.
        }
      });

      // Determine if the user is an admin based on the API response
      setIsAdmin(response.data.success);
    } catch (error) {
      console.error("Error:", error.response?.data?.message || error.message);
      setIsAdmin(false); // Return false in case of an error
    }
  };

  useEffect(() => {
    checkForAdmin()
  })


  return (
    <Box sx={{ color: '#169a8f', fontWeight: 'bold' }}>
      <IconButton variant="outlined" onClick={handleOpen} sx={{ bgcolor: '#169a8f', '& .MuiSvgIcon-root': { fontSize: '2.5rem' } }}>
        <AddIcon />
      </IconButton>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 1300,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
          }}
        >
        <h4 style={{color: '#169a8f',marginBottom:'20px'}}>Add Activity</h4>
          <TextField
            id="date"
            label="Date"
            type="date"
            value={activityData.date}
            onChange={(e) => setActivityData({ ...activityData, date: e.target.value })}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            id="activity"
            label="Activity"
            value={activityData.text}
            onChange={(e) => setActivityData({ ...activityData, text: e.target.value })}
            fullWidth
            sx={{ mb: 2 }}
          />
          <Button variant="contained" onClick={handleSave} style={{ backgroundColor: '#169a8f' }}>
            Save
          </Button>
        </Box>
      </Modal>
      <Box mt={3}>
        {activities.map((activity, index) => (
          <Card key={index} sx={{ mb: 2,mt:3 }}>
            <CardContent>
              <Typography sx={{ fontSize: '15px', color: '#169a8f', fontWeight: '400', fontFamily: 'nunito' }} variant="subtitle1" color="textSecondary" gutterBottom>
                Date: {activity.date} | Time: {activity.time}
              </Typography>
              <Typography sx={{ wordWrap: 'break-word', fontSize: '8px', color: '#169a8f', fontWeight: '400',fontFamily: 'nunito'  }} variant="body1">{activity.text}</Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default ActivityPageForUser;